import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { updateUser } from '../actions'
import { Field, reduxForm, submit } from 'redux-form';
import { Form, Icon, Input, Button, Checkbox, Switch, Alert } from 'antd';
import Card, { TitleCard, CardHeader } from '../../core/Card'
import validate from './validate'


const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

const email = value =>
  value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(value)
    ? 'Invalid email address'
    : undefined

export const minLength = min => value =>
  value && value.length < min ? `Too short, use at least ${min} characters` : undefined

// ant wrapped redux form examples: https://codesandbox.io/s/JZYL70WpK
const makeField = Component => ({ input, meta, children, hasFeedback, label, ...rest }) => {
  const hasError = meta.touched && meta.invalid;
  return (
    <Form.Item
      {...formItemLayout}
      label={label}
      validateStatus={hasError ? 'error' : 'success'}
      hasFeedback={hasFeedback}
      help={hasError && meta.error}
    >
      <Component {...input} {...rest} children={children} />
    </Form.Item>
  );
};

const AInput = makeField(Input);
const ASwitch = makeField(Switch);


export const ChangePassword = ({submitChangePasswordForm, pristine, invalid, submitting, submitSucceeded, error, reset}) =>
  <Card>
    <CardHeader
      title="Change Password"
      buttonOnClick={submitChangePasswordForm}
      buttonDisabled={pristine}
      buttonTitle="Save"
      buttonLoading={submitting}
      buttonClassName="ant-btn-primary"
    />

    <Field
      name="password"
      type="password"
      component={AInput}
      label="New Password"
      validate={minLength(6)}
    />

    <Field
      name="password_confirmation"
      type="password"
      component={AInput}
      label="Confirm Password"
      validate={minLength(6)}
    />

    <Field
      name="verify_password"
      type="password"
      component={AInput}
      label="Current Password"
    />
    { submitSucceeded ? <Alert message="User has been updated." type="success" /> : null}
    { error && <Alert message={error} type="error" />}
  </Card>



const mapStateToProps = (state, ownProps) => {
  const { user } = state.models
  return {
    initialValues: {
      password: user.password,
      password_confirmation: user.password_confirmation,
      verify_password: user.verify_password
    },
    enableReinitialize: true,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    submitChangePasswordForm: () => dispatch(submit('changePassword')),

  }
}

export default connect( mapStateToProps, mapDispatchToProps )(
  reduxForm({
    form: 'changePassword',
    onSubmit: (values, dispatch)=> dispatch(updateUser(values)),
    validate
  })(ChangePassword)
)



// WEBPACK FOOTER //
// ./src/account/profile/ChangePassword.jsx